import React from 'react';

import { Radio as ChakraRadio } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledRadio = styled(ChakraRadio)`
  background: white;
  border-color: #333333;
  &:hover {
    border-color: #1565bc;
    &.radioChecked {
      background: white;
      border-color: #1565bc;
      &::before {
        width: 60%;
        height: 60%;
        background: #1565bc;
      }
    }
  }
  &[data-disabled] {
    &:hover {
      border-color: #e2e8f0;
    }
  }
  &.radioChecked {
    background: white;
    border-color: #1565bc;
    &::before {
      width: 60%;
      height: 60%;
      background: #1565bc;
    }
    &[data-disabled] {
      background: #e2e8f0;
      &::before {
        opacity: 0.5;
      }
    }
  }
`;

const Radio = ({ isChecked = false, isDisabled = false, name, onChange, ...props }) => (
  <StyledRadio
    className={isChecked ? 'radioChecked' : ''}
    isChecked={isChecked}
    isDisabled={isDisabled}
    name={name}
    onChange={onChange}
    {...props}
  />
);

export { Radio };
